function getTooltip() {
    return document.getElementById('tooltip')!  
}

export function hideTooltip() {
    const tooltip = getTooltip()
    tooltip.style.display = 'none'
}

export function createTooltip(el: HTMLElement, value: any) {
    let timer: NodeJS.Timeout
    el.onmouseover = () => {
        const tooltip = getTooltip()
        const position = value.pos || 'top'
        const rect = el.getBoundingClientRect()
        tooltip.innerHTML = '<span>' + (value.text || value) + '</span>'
        tooltip.className = 'no-mobile tooltip-' + position + (value.large ? ' tooltip-large' : '')
        tooltip.style.display = 'flex'
        tooltip.style.opacity = '1'
        if (position == 'right') {
        tooltip.style.width = '0px'
        tooltip.style.height = rect.height + 'px'
        tooltip.style.transform = `translate(${rect.left + rect.width}px, ${rect.top}px)`        
        } else {
        tooltip.style.height = '0px'
        tooltip.style.width = rect.width + 'px'
        tooltip.style.transform = `translate(${rect.left}px, ${rect.top}px)`        
        }
        timer = setTimeout(() => {
        // tooltip.style.display = 'flex'
        }, 200)
    }
    el.onmouseout = () => {
        const tooltip = getTooltip()
        tooltip.style.opacity = '0'
        clearTimeout(timer)
    }
}


